import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";
import { JoeHttp, Schema } from "../../../../../@types";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const http: Schema<JoeHttp> = {
  fields: [
    {
      name: "timestamp",
      displayTitle: "Timestamp",
      sortable: true,
      component: d => <>{d.timestamp}</>
    },
    {
      name: "srcip",
      displayTitle: "Source IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.srcip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "srcport",
      displayTitle: "Source port",
      sortable: true,
      component: d => <>{d.srcport}</>
    },
    {
      name: "dstip",
      displayTitle: "Destination IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.dstip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "out",
      displayTitle: "Direction",
      sortable: true,
      component: d => <>{d.out ? "OUT" : "IN"}</>
    },
    {
      name: "_data",
      displayTitle: "Data",
      sortable: true,
      component: d => (
        <div>
          {d.header ? JSON.stringify(d.header.line ?? "") : ""}
          {/* eslint-disable-next-line no-underscore-dangle */}
          {d._data ? JSON.stringify(d._data.line ?? "") : ""}{" "}
          {/* eslint-disable-next-line no-underscore-dangle */}
          {!d.header && !d._data ? "--" : ""}
        </div>
      )
    }
  ]
};
